module.exports = __webpack_public_path__ + "static/media/gravure4.71c6fd25.jpg";